var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_567_2289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_567_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6C10.5667 21.5 9.25836 21.1459 8.07503 20.5375C6.89169 19.9292 5.87919 19.1125 5.03752 18.0875C4.19586 17.0625 3.54586 15.8542 3.08752 14.4625C2.62919 13.0709 2.40002 11.55 2.40002 9.90002V9.00002H3.29002C4.04669 9.00002 4.87919 9.12502 5.78752 9.37502C6.69586 9.62502 7.53336 9.95836 8.30002 10.375C8.46669 9.07502 8.87919 7.71252 9.53753 6.28752C10.1959 4.86252 11.0167 3.56669 12 2.40002C12.9834 3.56669 13.8 4.85419 14.45 6.26252C15.1 7.67086 15.5167 9.03336 15.7 10.35C16.4667 9.95002 17.3042 9.62502 18.2125 9.37502C19.1209 9.12502 19.9534 9.00002 20.71 9.00002H21.6V9.90002C21.6 11.6 21.375 13.1459 20.925 14.5375C20.475 15.9292 19.8334 17.1334 19 18.15C18.1667 19.1667 17.1584 19.9709 15.975 20.5625C14.7917 21.1542 13.4667 21.5 12 21.6ZM11.975 19.8C11.825 17.2667 11.075 15.2167 9.72503 13.65C8.37502 12.0834 6.54169 11.1584 4.22502 10.875C4.39169 13.4084 5.12502 15.4625 6.42502 17.0375C7.72502 18.6125 9.57503 19.5334 11.975 19.8ZM12 13.725C12.2834 13.3084 12.6125 12.8917 12.9875 12.475C13.3625 12.0584 13.7 11.725 14 11.475C13.95 10.5917 13.7625 9.63336 13.4375 8.60003C13.1125 7.56669 12.6334 6.50836 12 5.42502C11.3667 6.50836 10.8834 7.57919 10.55 8.63753C10.2167 9.69586 10.0334 10.6417 10 11.475C10.349 11.7805 10.7154 12.1444 11.0993 12.5665C11.4831 12.9889 11.7834 13.375 12 13.725ZM13.725 19.45C14.6917 19.15 15.5375 18.7334 16.2625 18.2C16.9875 17.6667 17.6 17.0334 18.1 16.3C18.6 15.5667 18.9875 14.7417 19.2625 13.825C19.5375 12.9084 19.7084 11.925 19.775 10.875C18.2084 11.1584 16.8292 11.7084 15.6375 12.525C14.4459 13.3417 13.5584 14.4084 12.975 15.725C13.1544 16.2435 13.3075 16.8107 13.4345 17.4265C13.5615 18.0422 13.6584 18.7167 13.725 19.45Z",
    fill: "url(#paint0_linear_567_2289)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_2289",
    x1: 2.28337,
    y1: 3.23627,
    x2: 24.9198,
    y2: 10.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.fbad576b909bf291e66347c2a420bb88.svg";
export { ForwardRef as ReactComponent };